var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.186 17.6246C3.59517 17.6246 3.20163 17.2227 3.20163 16.6603V14.802C3.20163 14.2312 3.59517 13.8377 4.186 13.8377H6.64875C7.23957 13.8377 7.63312 14.2312 7.63312 14.802V16.6603C7.63312 17.2227 7.23957 17.6246 6.64875 17.6246H4.186ZM0 9.95366V7.60482H23.7658V9.95366H0ZM3.29504 20.8179H20.4708C22.6489 20.8179 23.7658 19.7074 23.7658 17.5641V6.69959C23.7658 4.55627 22.6489 3.4375 20.4708 3.4375H3.29504C1.12701 3.4375 0 4.55627 0 6.69959V17.5641C0 19.7074 1.12701 20.8179 3.29504 20.8179Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCard);
export default __webpack_public_path__ + "static/media/ic_card.db5b8bd85176153e70930f4ebbfeb8ff.svg";
export { ForwardRef as ReactComponent };